<template>
  <div class="common-problem-page">
    <Navbar class="nav-bar" v-model="selected">
      <TabItem class="nav-bar-item" :id="item" v-for="item in navBar" :key="item">{{item}}</TabItem>
    </Navbar>

    <div>
      <div class="item-question" v-for="item in TabContainer[selected]" :key="item.id">
        <div class="title">
          <span class="title-id">{{item.id}}</span>
          <span class="title-name">{{item.title}}</span>
        </div>
        <p class="content">{{item.content}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Navbar, TabItem, TabContainer, TabContainerItem, Cell } from 'mint-ui';
export default {
  components: { Navbar, TabItem },
  data () {
    return {
      selected: '购车',
      navBar: ['购车', '费用', '提车', '用车', '还款', '其他'],
      TabContainer: {
        '购车': [
          {
            id: 'Q1',
            title: '什么是“功夫好车"?',
            content: '- 功夫好车始创于2016年，总部位于北京，是一家集“汽车供应链、汽车服务”为一体的全场景、全覆盖的汽车新零售服务提供商，为用户提供轻松、低价、高品质的一站式购车服务，让好车得来全不费功夫！- 依托强大的资金实力、高效IT研发能力和数据运用能力，通过“汽车超市+社区体验店”的线下服务和线上电商相结合，重构了“人、车、店”的关系。并针对用户多样化的需求，通过完整的汽车供应链和金融产品创新，为用户提供“低首付、低门槛”的智慧化购车体验。- 目前业务覆盖北京、银川、大连、沈阳、郑州、唐山、承德等7个城市。2018年将在全国新增100个城市，未来三年将扩充至300个全国主要城市。'
          },
          {
            id: 'Q2',
            title: '功夫好车购车优势是？',
            content: '功夫好车始终坚持“相信口碑的力量”，坚持为用户提供“低首付、低门槛”的多品牌汽车购买服务，以“让每个用户都能买好车”为使命，不断为用户创造更好的服务。'
          },
          {
            id: 'Q3',
            title: '申请准备那些资料？',
            content: '身份证、驾驶证、银行卡等资料。'
          },
          {
            id: 'Q4',
            title: '功夫好车的车是新车吗？',
            content: '我们所有的车都从厂家直接采购，并由厂家直接配送到门店，所有车保证是新车。'
          },
          {
            id: 'Q5',
            title: '功夫好车的车来源是？',
            content: '我们所有的车都从厂家直接采购或从当地4S店采购，并由厂家直接配送到门店，我们所有的车都可以在当地的4S店享受标准的售后维修与保养服务。'
          }
        ],
        '费用': [
          {
            id: 'Q1',
            title: '首付款一般多少？',
            content: '我们提供不同产品方案，最低首付只需3999元。'
          }
        ],
        '提车': [
          {
            id: 'Q1',
            title: '签约后多久可以提车？',
            content: '我们这边最快当日可提车，最慢2周内能提车。'
          }
        ],
        '用车': [
          {
            id: 'Q1',
            title: '上牌谁负责？',
            content: '功夫好车负责给您的爱车上牌照。'
          },
          {
            id: 'Q2',
            title: '过户如何办理？',
            content: '车辆过户由功夫好车负责，但需要您的配合。'
          },
          {
            id: 'Q3',
            title: '来年保险由谁负责？',
            content: '功夫好车含首年保险，后续保险费用由您承担，同时功夫好车提供续保的优惠政策，您可委托我们统一上保险。'
          },
          {
            id: 'Q4',
            title: '违章了怎么处理？',
            content: '您违章后，功夫好车会以短信等方式提醒您，您务必于年检前处理违章。功夫好车也提供违章处理代办服务，但需要收取一定的费用。'
          }
        ],
        '还款': [
          {
            id: 'Q1',
            title: '会提前提醒还款吗？',
            content: '功夫好车会在您的还款日提前3日短信提醒您，请注意查收您的短信。'
          },
          {
            id: 'Q2',
            title: '扣款失败怎么办？',
            content: '如果因各种原因扣款失败，功夫好车会通知您扣款失败，同时您可选择在功夫好车APP或微信公众号进行还款。'
          },
          {
            id: 'Q3',
            title: '如果中途没钱还款怎么办？',
            content: '目前我们暂不支持部分还款，未来维护您的良好信用记录，我们希望您确保按时足额还款。功夫好车正在开发部分还款的产品，待推出后我们及时通知您。'
          },
          {
            id: 'Q4',
            title: '可以提前结清吗？',
            content: '我们支持提前结清，届时您只需要支付剩余本金及少量的手续费。'
          }
        ],
        '其他': [
          {
            id: 'Q1',
            title: '期满前是否可以退车',
            content: '期满前暂不支持退车。'
          }
        ]
      }
    };
  }
};
</script>
<style>
.mint-tab-container {
  margin-top: 3px;
}
.mint-navbar .mint-tab-item.is-selected {
  font-family: 'PingFangSC-Medium';
  color: #000 !important;
  border-bottom: 2px solid #EDD826 !important;
}
.mint-tab-item-label {
  font-size: 14px;
  line-height: 22px;
  color: #7F7F7F;
}
</style>

<style lang="postcss" scoped>
.nav-bar {
  padding: 0 48px;
  height: 77px;
}
.nav-bar-item {
  padding: 16px 0;
}
.item-question {
  padding: 30px;
  text-align: justify;
  border-bottom: 1px solid #E4E4E4;
}
.item-question:last-child  {
  border-bottom: none;
}
.title {
  padding: 10px 0;
  font-size: 30px;
  line-height: 42px;
  font-family: 'PingFangSC-Medium'
}
.title .title-id{
  padding-right: 20px;
  color: #E28808;
  line-height: 42px;
}
.title .title-name{
  color: #000;
}
.content {
  font-size: 26px;
  line-height: 42px;
  color: #7F7F7F;
}
</style>
